import moment from 'moment';
import { getViaAuth, responseValidator } from 'apis/api';
import { API } from 'apis';
import { LoginResult } from 'routes/pages/sign-in/login-with-password/login-with-passowrd';

/**
 * توکن و اطلاعات نشست را در localStorage ذخیره می‌کند.
 * منطق مشترک صفحه ورود با رمز و صفحه کد تایید دو مرحله‌ای.
 */
export function persistSession(value: LoginResult) {
    value.accessToken && localStorage.setItem('accessToken', value.accessToken);
    value.refreshToken && localStorage.setItem('refresh', value.refreshToken);
    localStorage.setItem('date', moment.utc().toString());
    value.expiresIn && localStorage.setItem('expiresIn', value.expiresIn.toString());
    localStorage.setItem('isAuthorized', String(value.isAuthorized));
    localStorage.setItem('level', String(value.isTwoFactorEnabled));
    value.roles && localStorage.setItem('roles', value.roles.join(','));
    localStorage.setItem('tokenType ', value.tokenType);
}

/** آیتم‌های منوی مجاز کاربر را می‌گیرد و ذخیره می‌کند. */
export async function fetchAndStoreMenuItems() {
    const res: any = await getViaAuth(API.roles.getMineMenuItems);
    if (responseValidator(res.status) && res.data) {
        localStorage.setItem('menuItems', JSON.stringify(res.data));
    }
}
